import { Text } from "@radix-ui/themes";

import { CanvasBlockRenderer } from "../CanvasBlockRenderer";
import { type CanvasBlock } from "../types";

interface CardBlockProps {
  title: string;
  subtitle?: string;
  badge?: CanvasBlock;
  children: CanvasBlock[];
}

export function CardBlock({
  title,
  subtitle,
  badge,
  children,
}: CardBlockProps) {
  return (
    <div className="rounded-xl border border-puntt-neutral-gray-6 bg-base-white p-5 shadow-sm transition-shadow duration-200 hover:shadow-md">
      <div className="mb-4 h-0.5 w-12 rounded-full bg-puntt-accent-9" />
      <div className="mb-2 flex items-start justify-between gap-2">
        <div>
          <Text size="3" weight="bold" className="text-puntt-neutral-gray-12">
            {title}
          </Text>
          {subtitle && (
            <Text as="p" size="2" className="mt-0.5 text-puntt-neutral-gray-9">
              {subtitle}
            </Text>
          )}
        </div>
        {badge && <CanvasBlockRenderer block={badge} />}
      </div>
      <div className="space-y-2">
        {children.map((child, idx) => (
          <CanvasBlockRenderer key={idx} block={child} />
        ))}
      </div>
    </div>
  );
}
